const initialState = {
  loading: false,
  data: null,
  error: null,
};

export const executiveSnapshotReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_EXECUTIVE_SNAPSHOT_REQUEST":
      return { ...state, loading: true, error: null };
    case "GET_EXECUTIVE_SNAPSHOT_SUCCESS":
      return { loading: false, data: action.payload, error: null };
    case "GET_EXECUTIVE_SNAPSHOT_FAILURE":
      return { loading: false, data: null, error: action.payload };
    default:
      return state;
  }
};
